import { useState } from 'react';
import { useEventListener } from './use-event-listener';
import { WindowCenter } from './types';

/**
 * Listen for `resize` events and store the current window width, height and center.
 */
interface WindowSize {
  windowW: number;
  windowH: number;
  windowCenter: WindowCenter;
  orientation: string | null;
}
export function useWindowSize(): WindowSize {
  const [dimensions, setDimensions] = useState<WindowSize>({
    windowW: 0,
    windowH: 0,
    windowCenter: {
      x: 0,
      y: 0
    },
    orientation: null
  });
  useEventListener('resize', () => {
    setDimensions({
      windowW: window.innerWidth,
      windowH: window.innerHeight,
      windowCenter: {
        x: window.innerWidth / 2,
        y: window.innerHeight / 2
      },
      orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
    });
  },
  // Calls the callback once on mount
  {
    initial: true
  });
  return dimensions;
}